import React from "react"
import { Main, SpanBox, Shadow } from "./style"

interface Props {
  backgroundImage: string;
  title: string;
  subtitle: string;
}

const ServiceHeader: React.FC<Props> = ({ backgroundImage, title, subtitle }) => {
  return (
    <Main backgroundImage={backgroundImage}>
      <Shadow />
      <SpanBox>
        <h1>{title}</h1>
        <h2>{subtitle}</h2>
      </SpanBox>
    </Main>
  )
}

export default ServiceHeader

